import { apiGet } from "../apiUtils";

/**
 * Response structure for user-specific feature flags data
 */
export interface FeatureFlagData {
  userFeatures: {
    featureId: string;
    treatmentId: string;
  }[];
}

/**
 * API response wrapper for feature flags
 */
export interface FeatureFlagResponse {
  success: boolean;
  data: FeatureFlagData;
}

/**
 * Retrieves feature flags for the current authenticated user
 *
 * @returns Promise resolving to user-specific feature flags with their treatment assignments
 * @throws Error if the API request fails or returns invalid data
 *
 * @example
 * ```typescript
 * const response = await getFeatureFlags();
 * console.log(response.data.userFeatures);
 * // [{ featureId: "new-ui", treatmentId: "ENABLED" }]
 * ```
 */
export const getFeatureFlags = async (): Promise<FeatureFlagResponse> => {
  const restOperation = apiGet("/featureFlags/user");
  const { body } = await (await restOperation).response;
  return (await body.json()) as unknown as FeatureFlagResponse;
};
